import flow from "lodash/flow"
import flatten from "lodash/flatten"
import snakeCase from "lodash/snakeCase"
import fromPairs from "lodash/fromPairs"

function createNamesHashMap(scopeName) {
  return names =>
    names.map(name => [name, `${scopeName}_${snakeCase(name).toUpperCase()}`])
}

function addPrefix(prefix) {
  return name => `${prefix}${name}`
}

function amplifyNames(name) {
  return [``, `Success`, `Error`, `Cancel`].map(addPrefix(name))
}

export default function factorizeFetchLifecycleNames(actions, scopeName) {
  return flow(
    flatten,
    createNamesHashMap(scopeName),
    fromPairs,
  )(actions.map(amplifyNames))
}
